// extracted by mini-css-extract-plugin
module.exports = {"container":"analytics_container__2VzLe","wrapper":"analytics_wrapper__24seV","title":"analytics_title__Ea4k3","create":"analytics_create__3MXmB","count":"analytics_count__1_Ek9"};